// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
// @todo: Migrate to 'DropdownMenu' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import React, {FC} from 'react';

import {Analytics} from '../../../../services/analytics';
import {useSemanticLegendSettingsContext} from './SemanticLegendSettingsWithCategoricalConfigContextProvider';
import {invertColorsWithCategoricalConfig} from './utils/invertColors';
import {resetColors} from './utils/resetColors';
import {useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig} from './utils/useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig';

interface SemanticLegendBucketsActionsProps {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isOpen: boolean;
}

export const SemanticLegendBucketsActionsWithCategoricalConfig: FC<
  SemanticLegendBucketsActionsProps
> = ({setIsOpen, isOpen}) => {
  const {semanticLegendSettings, updateSemanticLegendSettings} =
    useSemanticLegendSettingsContext();
  const getSemanticLegendPalette =
    useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig();

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenu.Trigger>
        <Button
          active={isOpen}
          data-test="buckets-actions-overflow"
          icon="overflow-horizontal"
          variant="ghost"
          aria-label="More actions"
          size={'small'}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content align="center">
          <DropdownMenu.Item
            data-test="invert-colors-button"
            onClick={() => {
              Analytics.track('Semantic legend invert colors', {
                newValue: semanticLegendSettings.yAxisValue,
              });
              updateSemanticLegendSettings?.(
                invertColorsWithCategoricalConfig(
                  semanticLegendSettings,
                  getSemanticLegendPalette(semanticLegendSettings.yAxisValue)
                )
              );
              handleClose();
            }}>
            <Icon name="swap" /> Invert colors
          </DropdownMenu.Item>
          <DropdownMenu.Item
            data-test="reset-colors-button"
            onClick={() => {
              Analytics.track('Semantic legend reset colors', {
                newValue: semanticLegendSettings.yAxisValue,
              });
              updateSemanticLegendSettings?.(
                resetColors(semanticLegendSettings ?? {})
              );
              handleClose();
            }}>
            <Icon name="reload-refresh" /> Reset colors
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
